import { memo } from 'react';

import { ScArrowNext, ScArrowPrev } from './styled';

interface IInsideArrows {
  visibleForMobile?: boolean;
  isBeginning: boolean;
  isEnd: boolean;
  dark?: boolean;
  handlePrevClick: () => void;
  handleNextClick: () => void;
  hideArrows: boolean;
  insetLeftArrow?: string;
  insetRightArrow?: string;
  loop?: boolean;
  isOne?: boolean;
}

export const InsideArrows = memo(
  ({
    loop,
    visibleForMobile,
    insetRightArrow,
    insetLeftArrow,
    handlePrevClick,
    handleNextClick,
    isBeginning,
    isEnd,
    hideArrows,
    isOne,
  }: IInsideArrows) => {
    if (isOne) return null;
    return (
      <>
        <ScArrowPrev
          aria-label="arrow left"
          data-testid="slider-prev-arrow"
          hide={hideArrows || (!loop && isBeginning)}
          inset={insetLeftArrow}
          onClick={handlePrevClick}
          visibleForMob={visibleForMobile}
        />
        <ScArrowNext
          aria-label="arrow right"
          data-testid="slider-next-arrow"
          hide={hideArrows || (!loop && isEnd)}
          inset={insetRightArrow}
          onClick={handleNextClick}
          visibleForMob={visibleForMobile}
        />
      </>
    );
  }
);
